import types, {
  DELETE_ADDRESS_ACTION_TYPE,
  EDIT_PROFILE_ACTION_TYPE,
  ORDERS_NEEDS_ACTION_ACTION_TYPE,
} from "./types";
import globalTypes from "../global/types";
import utils from "./utils";

export const init_state = {
  app_data_loading: true,
  app_data_failed: false,
  app_data_updatedAt: 0,
  login: {
    cellphone: "",
    meta: {},
  },
  profile: null,
  groups: [],
  selectedGroup: null,
  token: null,
  address: undefined,
  orders: undefined,
  orders_needs_action: undefined,
  transactions: undefined,
};

export default function userReducer(state = init_state, action) {
  switch (action.type) {
    case types.LOGIN_SET_PHONE:
      return utils.reducer_setPhoneData(state, action.payload);
    case types.SET_TOKEN:
      return utils.reducer_setToken(state, action.payload);
    case types.SET_PROFILE:
      return utils.reducer_setProfile(state, action.payload);
    case types.SET_GROUPS:
      return utils.reducer_setGroups(state, action.payload);
    case types.SET_SELECTED_GROUP:
      return utils.reducer_setSelectedGroup(state, action.payload);
    case types.SET_ADDRESS:
      return utils.reducer_user_address(state, action.payload);
    case types.ADD_SINGLE_ADDRESS:
      return utils.reducer_add_single_address(state, action.payload);
    case types.SET_ORDERS:
      return utils.reducer_set_orders(state, action.payload);
    case types.SET_TRANSACTIONS:
      return utils.reducer_set_transactions(state, action.payload);
    case types.SET_RESET:
      return utils.reducer_set_reset(state, action.payload);
    case DELETE_ADDRESS_ACTION_TYPE:
      return utils.reducer_delete_address(state, action.payload);
    case EDIT_PROFILE_ACTION_TYPE:
      return utils.reducer_edit_profile(state, action.payload);
    case ORDERS_NEEDS_ACTION_ACTION_TYPE:
      return utils.reducer_orders_needs_action(state, action.payload);
    case globalTypes.LOGOUT:
      return utils.reducer_logout_user(state);
    default:
      return state;
  }
}
